import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Company } from './company.models';

export const CompanyActions = createActionGroup({
  source: 'Company',
  events: {
    Load: emptyProps(),
    'Redirect To Company Page': emptyProps(),
    'Redirect To Online Shop': emptyProps(),
  },
});

export const CompanyApiActions = createActionGroup({
  source: 'Company API',
  events: {
    'Loaded Success': props<{ company: Company }>(),
    'Loaded Failure': emptyProps(),
  },
});
